import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
      border: theme.shape.borderGray60,
      borderWidth: 0.5,
      backgroundColor: COLORS.neutral.white,
      padding: theme.spacing(2),
      maxHeight: 48,

      '&$disabled': {
        backgroundColor: COLORS.gray.gray80,
      },

      '&:hover': {
        border: theme.shape.borderGray50,
      },
    },
    disabled: {},
    active: {
      borderColor: COLORS.primary.default,
      '&:hover': {
        borderColor: COLORS.primary.default,
        border: theme.shape.borderGray60,
      },
    },
    texts: {
      flex: 1,
      display: 'flex',
      flexFlow: 'column nowrap',
      flexDirection: 'row',
      gap: theme.spacing(3),
      textAlign: 'start',
      overflow: 'hidden',
      justifyContent: 'space-between',
    },
    mainTexts: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      width: '100%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    maxCharsTitle: {
      color: COLORS.gray.black,
      flexShrink: 0,

      '$disabled &': {
        color: COLORS.gray.gray50,
      },
    },
    formulaTitle: {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      color: COLORS.gray.black,

      '$disabled &': {
        color: COLORS.gray.gray50,
      },
    },
    dot: {
      flexShrink: 0,
      color: COLORS.gray.gray60,

      '$disabled &': {
        color: COLORS.gray.gray50,
      },
    },

    subtitle: {
      color: '#8C8C8C',
      flexShrink: 0,

      '$disabled &': {
        color: COLORS.gray.gray50,
      },
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      marginLeft: theme.spacing(1),
      '$disabled &': {
        color: COLORS.gray.gray50,
      },
    },
  }),
  { name: 'FormulaItem' }
);
